<script setup lang="ts">
import ConciergeTakeover from './ConciergeTakeover.vue'
import { type ConciergeInputVariantName } from './ConciergeInputVariant.vue'
import { trackConciergeEvent } from './conciergeEventTracking'
import { localCalendarDate } from './seasonalDates'

// Thin composition point: the chosen input variant passes straight through to the
// takeover, where the input renders. Both variants write the same store, so nothing
// downstream depends on which one is picked.
// `referenceDate` is the server's calendar day (YYYY-MM-DD). This island server-renders and
// then hydrates, and the taps input orders its chips by how close a holiday is, so both passes
// must agree on what day it is — the browser's clock can already be tomorrow in UTC terms.
withDefaults(defineProps<{
  variant?: ConciergeInputVariantName
  referenceDate?: string
}>(), { variant: 'free_text', })

const today = computed(() => (__props.referenceDate ? localCalendarDate(__props.referenceDate) : undefined))

onMounted(() => trackConciergeEvent('impression', { variant: __props.variant }))
</script>

<template>
  <div class="w-full">
    <ConciergeTakeover :variant="variant" :referenceDate="today"/>
  </div>
</template>
